import { useTranslation } from "react-i18next";
import type { AgentKeyInfo } from "../../services/naraDoor";

interface AgentKeyListProps {
  keys: AgentKeyInfo[];
  revokingId: string | null;
  onRevoke: (keyId: string) => void;
}

/** Prefix, dates and state of each key, with Revoke on the active ones. The raw key is never here. */
export function AgentKeyList({ keys, revokingId, onRevoke }: AgentKeyListProps) {
  const { t, i18n } = useTranslation();
  const date = (iso: string) => new Date(iso).toLocaleDateString(i18n.language);

  if (keys.length === 0) return <p className="text-sm text-muted-foreground">{t("agent.keys.empty")}</p>;

  return (
    <ul className="divide-y divide-border">
      {keys.map((k) => (
        <li key={k.key_id} className="py-3 flex items-center justify-between gap-3">
          <div className="min-w-0">
            <div className="text-sm font-medium text-foreground font-mono truncate">
              {k.key_prefix}…
              <span className={`ml-2 font-sans text-xs ${k.active ? "text-green-700 dark:text-green-300" : "text-muted-foreground"}`}>
                {k.active ? t("agent.keys.active") : t("agent.keys.revoked")}
              </span>
            </div>
            <div className="text-xs text-muted-foreground">
              {[t("agent.keys.created", { date: date(k.created_at) }), k.last_used_at ? t("agent.keys.lastUsed", { date: date(k.last_used_at) }) : t("agent.keys.neverUsed")].join(" · ")}
            </div>
          </div>
          {k.active && (
            <button type="button" onClick={() => onRevoke(k.key_id)} disabled={revokingId !== null} className="text-sm text-red-600 hover:underline disabled:opacity-50">
              {t("agent.keys.revoke")}
            </button>
          )}
        </li>
      ))}
    </ul>
  );
}
